import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL, BASE_LOGIN_API_URL } from "../utility/URL";
//import { BASE_API_URL } from "../utility/Url";



const menulistbyUser = async () => {
  // console.log(headerConfig);
  const response = await axios
    .post(BASE_API_URL + "menu/menulist", {}, headerConfig);
  return response.data;
};

const menulist = async () => {
  const response = await axios
    .post(BASE_LOGIN_API_URL + "menulist2", {});
  return response.data;
};

// const getYearList = async () => {
//   const response = await axios
//       .post(BASE_LOGIN_API_URL + "yearList", {});
//   return response;
// };


const menuService = {
    menulistbyUser,
    menulist
};

export default menuService;